export var MessageDirection;
(function (MessageDirection) {
    MessageDirection["INBOUND"] = "INBOUND";
    MessageDirection["OUTBOUND"] = "OUTBOUND";
})(MessageDirection || (MessageDirection = {}));
export var ConversationSource;
(function (ConversationSource) {
    ConversationSource["SMS"] = "SMS";
    ConversationSource["WEB_CHAT"] = "WEB_CHAT";
    ConversationSource["FACEBOOK"] = "FACEBOOK";
    ConversationSource["INSTAGRAM"] = "INSTAGRAM";
})(ConversationSource || (ConversationSource = {}));
export const isMessageEvent = (event) => event && !!event['direction'];
export const isAssignEvent = (event) => !!event['assignedTo'];
export const isUnassignEvent = (event) => !!event['unassignedFrom'];
export const isResolveEvent = (event) => !!event['reason'];
export const isCallEvent = (event) => Object.keys(event).length === 4 && !!event['performedBy'];
export const isMeetingEvent = (event) => !!event['meetingId'];
export const isCobrowseStartedEvent = (event) => !!event['sessionPin'] && !!event['serviceUrl'];
export const isParticipantLeftEvent = (event) => Object.keys(event).length === 3 && !event['performedBy'];
export const isWebChatEndedEvent = (event) => !event.conversationId;
export const isWebChatAfterHoursEvent = (event) => !event['scheduleId'] && !!event['afterHoursMessage'];
export const isAgentAfterHoursEvent = (event) => !!event['scheduleId'] && !!event['afterHoursMessage'];
export const PENDING_MESSAGE_PREFIX = 'pending';
export const FAILED_MESSAGE_PREFIX = 'failed';
export var ParticipantHistoryType;
(function (ParticipantHistoryType) {
    ParticipantHistoryType["CALL"] = "CALL";
    ParticipantHistoryType["CHAT"] = "CHAT";
})(ParticipantHistoryType || (ParticipantHistoryType = {}));
export var ConversationResolutionReason;
(function (ConversationResolutionReason) {
    ConversationResolutionReason["RESOLVED"] = "RESOLVED";
    ConversationResolutionReason["RESOLVED_BY_ADMIN"] = "RESOLVED_BY_ADMIN";
    ConversationResolutionReason["SPAM"] = "SPAM";
    ConversationResolutionReason["NO_ACTIVITY"] = "NO_ACTIVITY";
    ConversationResolutionReason["CHAT_QUEUE_DELETED"] = "CHAT_QUEUE_DELETED";
    ConversationResolutionReason["SOURCE_DISABLED"] = "SOURCE_DISABLED";
})(ConversationResolutionReason || (ConversationResolutionReason = {}));
//# sourceMappingURL=types.js.map